import React, { Component } from 'react'
import { bookingReference } from 'helpers/bookingReference';
import { joinAddress } from 'components/Booking/BookingLayout';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import {
  Button, FormGroup, Checkbox, DateTimePicker,
  Intent, Spinner, RadioGroup, Radio, Divider, Dialog, Classes, Icon
} from "@blueprintjs/core";
import Toast from 'helpers/toaster';
import styled from '@emotion/styled';
import { Helmet } from 'react-helmet';
import Lockr from 'lockr';
import _ from 'lodash';
import BookingDateTimeInput from 'components/BookingDateTimeInput';
import moment from 'moment';
import GeoComplete from '../../helpers/GeoComplete';
import { currencySymbol, currencyFormattedAmount } from 'helpers/currency';
import QuestionRadio from 'components/Booking/QuestionRadio';
import QuestionSelect from 'components/Booking/QuestionSelect';
import QuestionTextbox from 'components/Booking/QuestionTextbox';
import BookingConfirmationMessage from 'pages/BookingConfirmationMessage';
import BookingStepper from 'components/BookingModal/Stepper';
import { ChoiceGroup, ChoiceCard } from 'components/BookingModal/ChoiceCards';
import { normalizeHex, serviceTypeColors } from 'helpers/serviceTypeColor';
import { flatOptionLabel, flatOptionQuantity } from 'helpers/bookingPricing';

var startCountRange = 0
var label = '';
var indexChecked = '';
var selectedAnswer = '';
var url_string = window.location.href;
var url = new URL(url_string);
var is_brand = url.searchParams.get("is_brand");
var princingRangeCombineArray = [];

const items = [
  { label: 'Cash', value: 'Cash' },
  { label: 'Interac', value: 'Interac' },
  { label: 'Cheque', value: 'Cheque' },
  { label: 'Debit/Credit', value: 'dr/cr' }
];

// One entry per bookingStep (1-6), in order.
const BOOKING_STEPS = [
  { label: 'Service', title: 'Choose a service', help: 'Pick a category, then the service you need.' },
  { label: 'Details', title: 'Service details', help: 'Tell us a little more so we can estimate the price.' },
  { label: 'Your info', title: 'Your info', help: 'How we can reach you about this booking.' },
  { label: 'Address', title: 'Service address', help: 'Where the work will take place.' },
  { label: 'Schedule', title: 'Schedule', help: 'When and how you would like us to come.' },
  { label: 'Finish', title: 'Almost done', help: 'Add a file or a note, then confirm the booking.' },
];

// Tenant booking colour as CSS custom properties on the modal root. Without a
// tenant colour the stylesheet defaults apply.
const brandStyle = (color) => {
  if (!color) return undefined;
  const hex = normalizeHex(color);
  const style = { '--bk-brand': hex || color };
  if (hex) {
    const [r, g, b] = [1, 3, 5].map((i) => parseInt(hex.substr(i, 2), 16));
    style['--bk-brand-tint'] = `rgba(${r}, ${g}, ${b}, 0.1)`;
    style['--bk-ring'] = `rgba(${r}, ${g}, ${b}, 0.18)`;
  }
  return style;
};

const PageWrapGray = styled('div')`
  min-height: calc(100vh - 75px);
  width: 100%;
`
@inject('bookingStore', 'preferenceStore', 'serviceTypeStore', 'pricingParameterStore', 'frequencyStore', 'questionGroupStore', 'store', 'viewStore','serviceTypeCategoryStore') @observer
class BookingModal extends Component {

  @observable pricingParameterArray = [];
  @observable tenant_logo = '';
  @observable tenant_name = '';

  constructor(props) {
    super(props);
    this.state = {
      isServiceTypeChecked: 0,
      isPaymentSelect: 0,
      isFrequencySelected: null
    };
  }

  @observable startCountRange = 0;
  @observable extra_service_total = 0;
  @observable pricing_parameter_total = 0;
  @observable pricing_range_total = 0;
  @observable grand_total = 0.0;
  @observable isServiceTypeChecked = 0;

  componentDidMount() {
    let {
      serviceTypeStore,
      questionGroupStore,
      serviceTypeCategoryStore,
      bookingStore: {
        booking: {
          object
        }
      }
    } = this.props;

    if (object && object.attributes) {
      this.grand_total = object.attributes.total;
    }
    serviceTypeCategoryStore.loadServiceTypeCategories();
    questionGroupStore.loadPublicQuestionGroups();

    // Booking settings (visit date, frequency, answer lists) live on the
    // tenant. The public form loads them into bookingStore.tenant; in the
    // dashboard nothing does, so use the account's own settings.
    const { bookingStore, preferenceStore } = this.props;
    const hasSettings = () => Boolean(bookingStore.tenant.object && bookingStore.tenant.object.attributes);
    if (!hasSettings()) {
      preferenceStore.loadTenant()
        .then((response) => {
          if (!hasSettings()) bookingStore.tenant.object = response.data.data;
        })
        .catch(() => {});
    }
    //serviceTypeStore.loadPublicServiceTypesBooking();
    const currentTenant = Lockr.get('currentTenant');
    if (currentTenant) {
      this.tenant_logo = currentTenant.logo;
      this.tenant_name = currentTenant.name;
    }
    window.$crisp.push(['do', 'chat:hide']);
  }

  onAddressSelect(suggestion) {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;
    if (suggestion) {
      object.attributes.address = suggestion.label;
      suggestion.gmaps && suggestion.gmaps.address_components && suggestion.gmaps.address_components.length > 0 && suggestion.gmaps.address_components.map((address_component) => {
        if (_.includes(address_component.types, "locality")) {
          object.attributes.city = address_component.long_name;
        }

        if (_.includes(address_component.types, "administrative_area_level_1")) {
          object.attributes.state = address_component.long_name;
        }

        if (_.includes(address_component.types, "postal_code")) {
          object.attributes.zip = address_component.long_name;
        }
      })
    } else {
      object.attributes.address = '';
      object.attributes.zip = "";
      object.attributes.state = "";
      object.attributes.city = "";
    }
  }

  onAddressClear(value) {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;
    if (!value) {
      object.attributes.address = '';
    }
  }

  onExtraServiceSelect(event, selectedOptions, key) {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;

    let index = object.attributes.booking_service_type_extras.map(function (item) { return item.name; }).indexOf(selectedOptions.name);
    if (event.target.checked === true) {
      if (index === -1) {
        object.attributes.booking_service_type_extras.push({ service_type_extra_id: selectedOptions.id, name: selectedOptions.name, price: parseFloat(selectedOptions.price_cents / 100) });
      } else {
        object.attributes.booking_service_type_extras[index].price = parseFloat(selectedOptions.price_cents / 100);
        object.attributes.booking_service_type_extras[index]._destroy = 0;
      }
    } else {
      object.attributes.booking_service_type_extras[index].price = 0;
      object.attributes.booking_service_type_extras[index]._destroy = 1;
    }
    this.calculateGrandtotal()
  }

  onFrequencySelect(event, selectedOptions, key) {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;
    object.attributes.frequency_id = selectedOptions.id;
    this.setState({
      isFrequencySelected: key,
    });
  }

  onPricingRangeSelectImage(event,selectedOptions,key) {  
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;

    if(event.target.checked){
      let index = object.attributes.pricing_parameter_ranges.map(function(item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.pricing_parameter_id);
      if(index > -1){
        object.attributes.pricing_parameter_ranges[index].pricing_parameter_id = selectedOptions.pricing_parameter_id;
        object.attributes.pricing_parameter_ranges[index].name = selectedOptions.label;
        object.attributes.pricing_parameter_ranges[index].price = selectedOptions.price;
        object.attributes.pricing_parameter_ranges[index].total_amount =  selectedOptions.price;
      }else{
        object.attributes.pricing_parameter_ranges.push({pricing_parameter_id:selectedOptions.pricing_parameter_id,name:selectedOptions.label,price:selectedOptions.price,total_amount:selectedOptions.price});
      }
      this.calculateGrandtotal()
    }
  }

  onPricingRangeSelect(event, selectedOptions) {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;
    // if(event.target.value != ''){
    //   object.attributes.pricing_parameter_ranges = [];
    //   object.attributes.pricing_parameter_ranges.push({pricing_parameter_id:selectedOptions.id,name:event.target.options[event.target.selectedIndex].text,price:parseFloat(event.target.value)});
    // } else {
    //   object.attributes.pricing_parameter_ranges = [];
    // }
    // this.calculateGrandtotal()

    if (event.target.value != '') {
      let index = object.attributes.pricing_parameter_ranges.map(function (item) { return item.pricing_parameter_id; }).indexOf(selectedOptions.id);
      if (index > -1) {
        object.attributes.pricing_parameter_ranges[index].pricing_parameter_id = selectedOptions.id;
        object.attributes.pricing_parameter_ranges[index].name = event.target.options[event.target.selectedIndex].text;
        object.attributes.pricing_parameter_ranges[index].price = parseFloat(event.target.value);
        object.attributes.pricing_parameter_ranges[index].total_amount = parseFloat(event.target.selectedIndex) * parseFloat(event.target.value);

      } else {
        object.attributes.pricing_parameter_ranges.push({ pricing_parameter_id: selectedOptions.id, name: event.target.options[event.target.selectedIndex].text, price: parseFloat(event.target.value), total_amount: parseFloat(event.target.value) });

      }
      this.calculateGrandtotal()
    }
  }

  onPricingSelect(event, selectedOptions) {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;

    if (event.target.value != '') {
      object.attributes.pricing_parameters = [];
      object.attributes.pricing_parameters.push({ pricing_parameter_id: selectedOptions.id, name: event.target.options[event.target.selectedIndex].text, price: parseFloat((selectedOptions.price_cents / 100)) });
      // NOTE: here price came from backend in cents
      // Quantity is the number in the option label ("Tires x 4" is 4), as the server prices it.
      const quantity = flatOptionQuantity(flatOptionLabel(event));
      object.attributes.pricing_parameters[0].quantity = quantity;
      object.attributes.pricing_parameters[0].total_amount = quantity * parseFloat((selectedOptions.price_cents / 100));
    } else {
      object.attributes.pricing_parameters = [];
    }
    this.calculateGrandtotal()
  }

  // The saved choice for a flat pricing parameter (e.g. "Tires x 3"), so its
  // select shows it. Saved bookings keep choices in booking_pricing_parameters,
  // new ones in pricing_parameters; both store the option text as `name`.
  selectedPricingLabel(pricing) {
    const { object } = this.props.bookingStore.booking;
    const attributes = (object && object.attributes) || {};
    // Option text has its whitespace collapsed by the browser (a name like
    // "Tires x " gives "Tires x  4" in code but "Tires x 4" as the option and
    // as the saved name), so compare and return the collapsed form.
    const tidy = (text) => String(text || '').replace(/\s+/g, ' ').trim();
    const saved = [...(attributes.booking_pricing_parameters || []), ...(attributes.pricing_parameters || [])]
      .map((item) => item && tidy(item.name));
    for (let i = pricing.range_start; i <= pricing.range_end; i++) {
      const label = tidy(`${pricing.name} ${i}`);
      if (saved.includes(label)) return label;
    }
    return '';
  }

  pricingList = (pricing) => {
    let {
      props: {
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
    let pricingToReturn = [];
    this.pricingParameterArray = [];
    for (let i = pricing.range_start; i <= pricing.range_end; i++) {
      let label = `${pricing.name} ${i}`;
      // A new booking has no booking_pricing_parameters yet.
      let indexChecked = (object.attributes.booking_pricing_parameters || []).map(function(item) { return item.name; }).indexOf(label);
      if(indexChecked > -1){
        pricingToReturn.push(<option id={pricing.id} key={i}>{pricing.name}{` ${i}`}</option>);
      }else{
        pricingToReturn.push(<option id={pricing.id} key={i}>{pricing.name}{` ${i}`}</option>);
      }
    }
    return pricingToReturn;
  };

  pricingRangeList = (pricing) => {
    let {
      props: {
        pricingParameterStore,
        pricingParameterStore: {
          pricingParameterDetailUpdate: {
            object
          }
        },
        bookingStore: {
          booking
        }
      }
    } = this;
    let {
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;
    let pricingRangeToReturn = [];

    if (pricing.id) {
      let index = pricing.pricing_parameter_ranges.map(function (item) { return item.pricing_parameter_id; }).indexOf(pricing.id);
      if (index > -1) {
        pricing.pricing_parameter_ranges.map((range) => {
          let label = `${range.label}`;
          let indexChecked = booking.object.attributes.pricing_parameter_ranges.map(function(item) { return item.name; }).indexOf(label);
          if(indexChecked > -1){
            pricingRangeToReturn.push(<option selected={'selected'} innertext={range.label} value={range.price} key={Math.random()}>{range.label}</option>);
          }else{
            pricingRangeToReturn.push(<option innerText={range.label} value={range.price}>{range.label}</option>);
          }
          
        });
      }
    }
    return pricingRangeToReturn;
  };

  handleStartDateChange(date) {
    let { object } = this.props.bookingStore.booking;
    if (date) {
      object.attributes.start_date = moment(date);
    }
  }

  onPaymentSelect = (event, payment, key) => {
    let { object } = this.props.bookingStore.booking;
    this.setState({
      isPaymentSelect: key,
    });
    object.attributes.payment_method = payment.value;
  }

  onContactWayChange = (event) =>{
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.contact_way = event.target.value;
  }

  onTimePeriodChange = (event) =>{
    let {
      bookingStore:{
        booking:{
          object: {
            attributes
          }
        }
      }
    } = this.props;
    attributes.start_project_expected_period = event.target.value;
  }

  onServiceTypeSelect = (event, service, key) => {
    let { object } = this.props.bookingStore.booking;
    let { serviceTypeStore, pricingParameterStore } = this.props;
    let {
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;
    if (service.attributes.id !== "") {
      this.setState({
        isServiceTypeChecked: service.attributes.id
      });
      princingRangeCombineArray = [];
      object.attributes.extra_service_types = [];
      object.attributes.pricing_parameters = [];
      object.attributes.pricing_parameter_ranges = [];
      object.attributes.service_type_id = service.attributes.id;
      serviceTypeStore.loadServiceTypeDetail({ uuid: service.attributes.id })
        .then((response) => {
          serviceTypeDetail.object.attributes && serviceTypeDetail.object.attributes.pricing_parameters.length > 0 && serviceTypeDetail.object.attributes.pricing_parameters.map((pricing_attr) => {
            // pricingParameterStore.loadPricingParameterDetail({uuid:pricing_attr.id})
            // .then(response => {
            //   princingRangeCombineArray.push(response.data.data)
            // })
          });
          this.calculateGrandtotal()
        })
    } else {
      this.props.serviceTypeStore.clearServiceTypeDetail()
      this.calculateGrandtotal()
    }
  }

  onServiceTypeCategoryChange = (event) => {
    let { object } = this.props.bookingStore.booking;
    this.props.viewStore.serviceTypeSearch.where.service_type_category_id = event.target.value;
    this.props.serviceTypeStore.loadServiceTypes() 
    object.attributes.service_type_category_id = event.target.value;
  }

  onServiceTypeChange = (event) => {
    let { object } = this.props.bookingStore.booking;
    let { serviceTypeStore, pricingParameterStore } = this.props;
    let {
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;
    if (event.target.value !== "") {
      this.setState({
        isServiceTypeChecked: event.target.value
      });
      princingRangeCombineArray = [];
      object.attributes.extra_service_types = [];
      object.attributes.pricing_parameters = [];
      object.attributes.pricing_parameter_ranges = [];
      object.attributes.service_type_id = event.target.value;
      serviceTypeStore.loadServiceTypeDetail({ uuid: event.target.value })
        .then((response) => {
          serviceTypeDetail.object.attributes && serviceTypeDetail.object.attributes.pricing_parameters.length > 0 && serviceTypeDetail.object.attributes.pricing_parameters.map((pricing_attr) => {
          });
          this.calculateGrandtotal()
        })
    } else {
      this.props.serviceTypeStore.clearServiceTypeDetail()
      this.calculateGrandtotal()
    }
  }

  calculateGrandtotal() {
    let {
      bookingStore: {
        booking: {
          object
        }
      },
      serviceTypeStore: {
        serviceTypeDetail
      }
    } = this.props;

    this.grand_total = 0.0;
    
    // Adding Service type price in grand total
    if (serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes) {
      this.grand_total += serviceTypeDetail.object.attributes.rate;
    }

    // Adding pricing parameters flat to grand total
    if (object && object.attributes.pricing_parameters && object.attributes.pricing_parameters.length > 0) {
      this.grand_total += _.sumBy(object.attributes.pricing_parameters, 'total_amount')
    }

    // Adding pricing parameters range to grand total
    if (object && object.attributes.pricing_parameter_ranges && object.attributes.pricing_parameter_ranges.length > 0) {
      this.grand_total += _.sumBy(object.attributes.pricing_parameter_ranges, 'price')
    }

    // Adding extra service types to grand total
    if (object && object.attributes.extra_service_types && object.attributes.extra_service_types.length > 0) {
      this.grand_total += _.sumBy(object.attributes.extra_service_types, 'price')
    }
  }

   createBooking(status) {
    let {
      props: {
        store,
        frequencyStore:{
          frequencies
        },
        serviceTypeStore: {
          serviceType:{
            objects,
          }
        },
        bookingStore: {
          booking: { 
            object
           }
        }
      }
    } = this;
   
    
    if(object.attributes.first_name === "" || object.attributes.first_name === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid first name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.last_name === "" || object.attributes.last_name === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid last name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.email === "" || object.attributes.email === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid email!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.phone === "" || object.attributes.phone === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid phone!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.address === "" || object.attributes.address === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid address!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.city === "" || object.attributes.city === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid city name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.state === "" || object.attributes.state === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid state name!', intent: Intent.DANGER })
      return;
    }
    if(object.attributes.zip === "" || object.attributes.zip === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please enter valid zip code!', intent: Intent.DANGER })
      return;
    }

    if(object.attributes.service_type_category_id === "" || object.attributes.service_type_category_id === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please select service type category!', intent: Intent.DANGER })
      return;
    }
    
    if(object.attributes.service_type_id === "" || object.attributes.service_type_id === null) {
      Toast.show({ icon: 'warning-sign', message: 'Please select service type!', intent: Intent.DANGER })
      return;
    }
    
    // if(object.attributes.frequency_id === "" || object.attributes.frequency_id === 0) {
    //   Toast.show({ icon: 'warning-sign', message: 'Please select frequency!', intent: Intent.DANGER })
    //   return;
    // }

    if(object.attributes.payment_method === "" || object.attributes.payment_method === null) {
      object.attributes.payment_method = 'Cash';
    }

    object.attributes.total = this.grand_total;
     if (object.attributes.pricing_parameter_ranges != "" || object.attributes.pricing_parameter_ranges != null) { object.attributes.booking_pricing_parameters_attributes = object.attributes.pricing_parameters.concat(object.attributes.pricing_parameter_ranges);}
     else {
       object.attributes.booking_pricing_parameters_attributes = object.attributes.pricing_parameters;
     }   
    object.attributes.booking_service_type_extras_attributes = object.attributes.extra_service_types;
    object.attributes.status = status;
    object.attributes.booking_questions_attributes = object.attributes.booking_questions;

    this.props.bookingStore
      .createBooking()
      .then(response => {
        const created = response.data.data;
        Toast.show({
          icon: "tick",
          message: `Booking ${bookingReference(created.id)} ${created.attributes.status === 'confirmed' ? 'confirmed' : 'saved as draft'}`,
          intent: Intent.SUCCESS,
          timeout: 8000,
          action: { text: 'Open', onClick: () => this.props.viewStore.bookingShow({ uuid: created.id }) },
        });
        this.props.onClose();

      })
      .catch(error => {
        Toast.show({
          icon: "warning-sign",
          message: "Unable to create Booking!",
          intent: Intent.DANGER
        });
      });

  }

  onQuestionChange = (event, question) => {
    let {
      props: {
        bookingStore: {
          booking: {
            object
          }
        }
      }
    } = this;
    let index = object.attributes.booking_questions_attributes.map(function (item) { return item.question_id; }).indexOf(question.id);
    if (index > -1) {
      object.attributes.booking_questions_attributes[index].answer = event.target.value;
    } else {
      object.attributes.booking_questions_attributes.push({ answer: event.target.value, question_id: question.id });
    }
  }

  onChangeFile(event) {
    let {
      bookingStore: {
        booking: {
          object: { attributes }
        }
      }
    } = this.props;
    var FileSize = event.target.files[0].size / 1024 / 1024; // in MB
    if (FileSize > 10) {
      Toast.show({ icon: 'warning-sign', message: 'File size exceeds 10 MB!', intent: Intent.DANGER })
      return
    }
    this.props.bookingStore.uploadBookingAttachment(event.target.files[0])
      .then(this.onSuccessfullUploadAttachment.bind(this))
      .catch(this.onFailUploadAttachment.bind(this))
  }

  onSuccessfullUploadAttachment(response) {
    let {
      bookingStore: {
        booking: {
          object
        }
      }
    } = this.props;
    object.attributes.booking_attachment_ids.push(response.data.data.attributes.id);
    object.attributes.booking_attachments.push(response.data.data.attributes);
  }

  onFailUploadAttachment(error) {
    this.props.bookingStore.showUploadAttachmentLoader = false;
    if (error.response && error.response.data && error.response.data.errors) {
      Toast.show({ icon: 'warning-sign', message: error.response.data.errors, intent: Intent.DANGER })
    } else {
      Toast.show({ icon: 'warning-sign', message: 'Something went wrong, failed to upload file!', intent: Intent.DANGER })
    }
  }

  removeAttachment(attachment) {
    let {
      bookingStore: {
        booking: {
          object
        }
      }
    } = this.props;
    var removeIndex = object.attributes.booking_attachments.map(function (item) { return item.id; }).indexOf(attachment.id);
    if (removeIndex > -1) {
      object.attributes.booking_attachments.splice(removeIndex, 1);
      object.attributes.booking_attachment_ids.splice(removeIndex, 1);
    }
  }

  validate(bookingStep) {
    let {
      props: {
        bookingStore,
        bookingStore: {
          booking,
          booking: {
            object
          }
        }
      }
    } = this;
    if (bookingStep === 3) {
      if (object.attributes.first_name === "" || object.attributes.first_name === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid first name!', intent: Intent.DANGER })
        return false;
      }
      if (object.attributes.last_name === "" || object.attributes.last_name === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid last name!', intent: Intent.DANGER })
        return false;
      }
      if (object.attributes.email === "" || object.attributes.email === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid email!', intent: Intent.DANGER })
        return false;
      }
      if (object.attributes.phone === "" || object.attributes.phone === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid phone!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }
    if (bookingStep === 4) {
      if (object.attributes.address === "" || object.attributes.address === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid address!', intent: Intent.DANGER })
        return false;
      }
      if (object.attributes.city === "" || object.attributes.city === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid city name!', intent: Intent.DANGER })
        return false;
      }
      if (object.attributes.state === "" || object.attributes.state === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid state name!', intent: Intent.DANGER })
        return false;
      }
      if (object.attributes.zip === "" || object.attributes.zip === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please enter valid zip code!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }
    if (bookingStep === 1) {
      if(object.attributes.service_type_category_id === "" || object.attributes.service_type_category_id === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please select service type category!', intent: Intent.DANGER })
        return;
      }
      if (object.attributes.service_type_id === "" || object.attributes.service_type_id === null) {
        Toast.show({ icon: 'warning-sign', message: 'Please select service type!', intent: Intent.DANGER })
        return false;
      }
      return true;
    }
    if (bookingStep === 5) {
      // if (object.attributes.frequency_id === "" || object.attributes.frequency_id === 0) {
      //   Toast.show({ icon: 'warning-sign', message: 'Please select frequency!', intent: Intent.DANGER })
      //   return false;
      // }
      return true;
    }
    if (bookingStep === 6) {
      // if (object.attributes.payment_method === "" || object.attributes.payment_method === null) {
      //   Toast.show({ icon: 'warning-sign', message: 'Please select payment method!', intent: Intent.DANGER })
      //   return false;
      // }
      return true;
    }
    if (bookingStep === 2) {
      return true;
    }

  }

  navigateToNextScreen() {
    let {
      props: {
        bookingStore,
        bookingStore: {
          bookingStep,
          booking,
          booking: {
            object
          }
        }
      }
    } = this;
    let result = this.validate(bookingStore.bookingStep);
    if (bookingStep < 7 && result === true) {
      bookingStore.bookingStep1 = false;
      bookingStore.bookingStep2 = false;
      bookingStore.bookingStep3 = false;
      bookingStore.bookingStep4 = false;
      bookingStore.bookingStep5 = false;
      bookingStore.bookingStep6 = false;

      bookingStore.bookingStep = bookingStep + 1;

      switch (bookingStore.bookingStep) {
        case 1:
          bookingStore.bookingStep1 = true;
          break;
        case 2:
          bookingStore.bookingStep2 = true;
          break;
        case 3:
          bookingStore.bookingStep3 = true;
          break;
        case 4:
          bookingStore.bookingStep4 = true;
          break;
        case 5:
          bookingStore.bookingStep5 = true;
          break;
        case 6:
          bookingStore.bookingStep6 = true;
          break;
        default:
        // code block
      }
    }
  }

  navigateToPreviousScreen() {
    let {
      bookingStore,
      bookingStore: {
        bookingStep
      }
    } = this.props;
    if (bookingStep > 1) {
      bookingStore.bookingStep = bookingStep - 1;

      bookingStore.bookingStep1 = false;
      bookingStore.bookingStep2 = false;
      bookingStore.bookingStep3 = false;
      bookingStore.bookingStep4 = false;
      bookingStore.bookingStep5 = false;
      bookingStore.bookingStep6 = false;
      switch (bookingStore.bookingStep) {
        case 1:
          bookingStore.bookingStep1 = true
          break;
        case 2:
          bookingStore.bookingStep2 = true
          break;
        case 3:
          bookingStore.bookingStep3 = true
          break;
        case 4:
          bookingStore.bookingStep4 = true
          break;
        case 5:
          bookingStore.bookingStep5 = true
          break;
        case 6:
          bookingStore.bookingStep6 = true
          break;
        default:
        // code block
      }
    }
  }

  handleCloseCopyDailog() {
    this.props.onClose();
  }

  handleSuccessCopyDailog() {
    this.props.onSuccess();
  }

  render() {
    let {
      store,
      serviceTypeStore: {
        serviceType,
        serviceType: {
          objects
        },
        serviceTypeDetail,
      },
      bookingStore: {
        bookingStep,
        bookingStep1,
        bookingStep2,
        bookingStep3,
        bookingStep4,
        bookingStep5,
        bookingStep6,
        showUploadAttachmentLoader,
        tenant,
        tenant: {
          object
        },
        booking:{
          object: {
            attributes
          },
          isLoading
        }
      },
      questionGroupStore: {
        groups
      },
      serviceTypeCategoryStore:{
        serviceTypeCategories
      }
    } = this.props;

    let service_type_extra = [];
    let pricing_parameters = [];
    let frequency = [];
    let questions = [];

    if (serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes) {
      service_type_extra = serviceTypeDetail.object.attributes.service_type_extra
      pricing_parameters = serviceTypeDetail.object.attributes.pricing_parameters
      frequency = serviceTypeDetail.object.attributes.frequency
      questions = serviceTypeDetail.object.attributes.questions;
    }

    // Tenant booking settings (the dashboard usually has none loaded).
    const tenantSettings = (object && object.attributes) || {};
    const stepMeta = BOOKING_STEPS[(bookingStep || 1) - 1] || BOOKING_STEPS[0];
    const selectedService = serviceTypeDetail && serviceTypeDetail.object && serviceTypeDetail.object.attributes;
    const selectedServiceColor = selectedService ? normalizeHex(selectedService.color) : null;
    const startDate = attributes && attributes.start_date ? moment(attributes.start_date) : null;
    const hasStartDate = startDate && startDate.isValid();
    const customerName = attributes ? [attributes.first_name, attributes.last_name].filter(Boolean).join(' ') : '';
    const pricingLines = attributes && attributes.pricing_parameters ? attributes.pricing_parameters : [];
    const rangeLines = attributes && attributes.pricing_parameter_ranges ? attributes.pricing_parameter_ranges : [];
    const extraLines = service_type_extra && service_type_extra.length > 0 && attributes && attributes.extra_service_types ? attributes.extra_service_types : [];
    const pricingTitle = tenantSettings.pricing_title != '' && tenantSettings.pricing_title ? tenantSettings.pricing_title : 'Pricing';

    return (
      <Dialog
        className="bk-modal"
        isOpen={this.props.isOpen}
        isCloseButtonShown={false}
        onClose={this.handleCloseCopyDailog.bind(this)}
        style={brandStyle(tenantSettings.booking_form_color)}
      >
        <div className="bk-modal__header">
          {this.tenant_logo &&
            <span className="bk-modal__logo"><img src={this.tenant_logo} alt="" /></span>
          }
          <div className="bk-modal__heading">
            <h2 className="bk-modal__title">New booking</h2>
            {this.tenant_name && <span className="bk-modal__tenant">{this.tenant_name}</span>}
          </div>
          <Button
            className="bk-modal__close"
            aria-label="Close"
            minimal={true}
            icon="cross"
            onClick={() => this.handleCloseCopyDailog(this)}
          />
        </div>

        <BookingStepper steps={BOOKING_STEPS.map((step) => step.label)} current={bookingStep || 1} />

        <div className="bk-modal__body">
          <div className="bk-modal__main">
            <div className="bk-modal__content">
              <div className="bk-modal__step-head">
                <h3 className="bk-modal__step-title">{stepMeta.title}</h3>
                <p className="bk-modal__step-help">{stepMeta.help}</p>
              </div>
              {
                bookingStep1 === true ?
                  <div className="bk-modal__step">
                    <div className="bk-section">
                      <div className="bk-section__head">
                        <span className="bk-label">Service category <span className="bk-required" aria-hidden="true">*</span></span>
                        { (serviceTypeCategories.objects.length === 0 || serviceType.isLoading) ?
                          <Spinner size={18} />
                          :
                          ""
                        }
                      </div>
                      {
                        serviceTypeCategories.objects &&
                        <ChoiceGroup label="Service category" className="bk-choices bk-choices--compact">
                          { serviceTypeCategories.objects.map((category) => {
                              const categoryId = String(category.attributes.id);
                              return (
                                <ChoiceCard
                                  key={category.attributes.id}
                                  className="bk-choice--category"
                                  checked={String(attributes.service_type_category_id) === categoryId}
                                  onSelect={() => { this.onServiceTypeCategoryChange({ target: { value: categoryId } }) }}
                                >
                                  <span className="bk-choice__check" aria-hidden="true"><Icon icon="tick" iconSize={10} /></span>
                                  <span className="bk-choice__name">{category.attributes.name}</span>
                                </ChoiceCard>
                              )
                            })
                          }
                        </ChoiceGroup>
                      }
                    </div>

                    {attributes && attributes.service_type_category_id != '' &&
                      <div className="bk-section">
                        <div className="bk-section__head">
                          <span className="bk-label">Service <span className="bk-required" aria-hidden="true">*</span></span>
                        </div>
                        <ChoiceGroup label="Service" className="bk-choices">
                          {objects && objects.map((service, key) => {
                            if (service.attributes.display_on_booking_form) {
                              const isChecked = service.id === attributes.service_type_id || service.attributes.id === attributes.service_type_id;
                              const hasRate = service.attributes.rate !== null && service.attributes.rate !== undefined && service.attributes.rate !== '';
                              return (
                                <ChoiceCard
                                  key={service.attributes.id || key}
                                  className="bk-choice--service"
                                  checked={isChecked}
                                  style={{ '--bk-service': serviceTypeColors(service.attributes.color).background }}
                                  onSelect={(event) => { this.onServiceTypeSelect(event, service, key) }}
                                >
                                  <span className="bk-choice__check" aria-hidden="true"><Icon icon="tick" iconSize={10} /></span>
                                  {service.attributes.logo ?
                                    <span className="bk-choice__logo"><img src={service.attributes.logo} alt="" /></span>
                                    :
                                    <span className="bk-choice__dot" aria-hidden="true" />
                                  }
                                  <span className="bk-choice__text">
                                    <span className="bk-choice__name">{service.attributes.name}</span>
                                    {hasRate && <span className="bk-choice__price">{currencyFormattedAmount(service.attributes.rate)}</span>}
                                  </span>
                                </ChoiceCard>
                              )
                            }
                          })
                          }
                        </ChoiceGroup>
                      </div>
                    }
                  </div>
                  : ''
              }
              {
                bookingStep2 === true ?
                  <div className="bk-modal__step">
                    {(!pricing_parameters || pricing_parameters.length === 0) &&
                      <p className="bk-empty">No extra details needed for this service. Continue to the next step.</p>
                    }
                    {pricing_parameters && pricing_parameters.length > 0 && <div className="bk-section">
                      <div className="bk-grid">
                        {
                          pricing_parameters && pricing_parameters.length > 0 && pricing_parameters.map((pricing, pricingKey) => {
                            if (pricing.pricing_type === 'flat') {
                              return (
                                <div className="bk-field" key={`flat-${pricing.id || pricingKey}`}>
                                  <FormGroup label={"Pricing"} labelFor="text-input">
                                    <select
                      value={this.selectedPricingLabel(pricing)}
                                      className='bk-input first-latter-capital'
                                      placeholder={`Select ${pricing.name}`}
                                      onChange={(event) => { this.onPricingSelect(event, pricing) }}
                                    >
                                      <option value="">Select any one</option>
                                      {this.pricingList(pricing)}
                                    </select>
                                  </FormGroup>
                                </div>
                              )
                            }
                          })
                        }
                      </div>
                      <div className="bk-grid">
                        {
                          pricing_parameters && pricing_parameters.length > 0 && pricing_parameters.map((pricing, pricingKey) => {
                            if (pricing.pricing_type === 'range') {
                              var index = pricing.pricing_parameter_ranges.length === _.filter(pricing.pricing_parameter_ranges, function(obj) { return obj.image_url }).length
                              return (
                                <div className={index === true ? 'bk-field bk-field--wide' : 'bk-field'} key={`range-${pricing.id || pricingKey}`}>
                                  <FormGroup
                                    label={pricing.name}
                                    labelFor="text-input"
                                    labelInfo={""}
                                    className="first-latter-capital"
                                  >
                                    {
                                      index === true ?
                                      <div className="bk-image-choices">
                                        {pricing.pricing_parameter_ranges.map((pricing_range,key) => {
                                          let indexChecked = attributes && attributes.pricing_parameter_ranges.map(function(item) { return item.name; }).indexOf(pricing_range.label);
                                          var checked_id ='';
                                          if(indexChecked > -1){
                                            checked_id = pricing_range.id;
                                          }
                                          return (
                                            <div className={`bk-image-choice${checked_id === pricing_range.id ? ' is-checked' : ''}`} key={pricing_range.id || key}>
                                              <img src={pricing_range.image_url} alt="" />
                                              <span className="bk-image-choice__foot">
                                                <Radio type="radio" name="checkboxgroup"
                                                  checked={checked_id === pricing_range.id ? true: false}
                                                  onChange={(event) => {this.onPricingRangeSelectImage(event,pricing_range,key)} }
                                                />
                                                <span className="bk-image-choice__label">{pricing_range.label}</span>
                                              </span>
                                            </div>
                                          )
                                        })}
                                      </div>:

                                      <select
                                        className='bk-input'
                                        placeholder={`Select ${pricing.name}`}
                                        onChange={(event) => { this.onPricingRangeSelect(event, pricing) }}
                                        >
                                        <option value="">Select any one</option>
                                        {this.pricingRangeList(pricing)}
                                      </select>

                                    }

                                  </FormGroup>
                                </div>
                              )
                            }
                          })
                        }
                      </div>
                    </div>}
                  </div>

                : ''
              }
              {
                bookingStep3 === true ?
                  <div className="bk-modal__step">
                    <div className="bk-grid">
                      <div className="bk-field">
                        <FormGroup
                          label={"First name"}
                          labelFor="bk-first-name"
                          labelInfo={"*"}
                        >
                          <input
                            id="bk-first-name"
                            type='text'
                            className='bk-input'
                            placeholder='First name'
                            autoComplete="given-name"
                            defaultValue={attributes.first_name}
                            onChange={(event) => { attributes.first_name = event.target.value; }}
                          />
                        </FormGroup>
                      </div>
                      <div className="bk-field">
                        <FormGroup
                          label={"Last name"}
                          labelFor="bk-last-name"
                          labelInfo={"*"}
                        >
                          <input
                            id="bk-last-name"
                            type='text'
                            className='bk-input'
                            placeholder='Last name'
                            autoComplete="family-name"
                            defaultValue={attributes.last_name}
                            onChange={(event) => { attributes.last_name = event.target.value; }}
                          />
                        </FormGroup>
                      </div>
                      <div className="bk-field">
                        <FormGroup
                          label={"Email address"}
                          labelFor="bk-email"
                          labelInfo={"*"}
                        >
                          <input
                            id="bk-email"
                            type='email'
                            className='bk-input'
                            placeholder='mail@domain.com'
                            autoComplete="email"
                            defaultValue={attributes.email}
                            onChange={(event) => { attributes.email = event.target.value; }}
                          />
                        </FormGroup>
                      </div>
                      <div className="bk-field">
                        <FormGroup
                          label={"Phone number"}
                          labelFor="bk-phone"
                          labelInfo={"*"}
                        >
                          <input
                            id="bk-phone"
                            type='text'
                            className='bk-input'
                            placeholder='Ex. 9876543210'
                            autoComplete="tel"
                            defaultValue={attributes.phone}
                            onChange={(event) => { attributes.phone = event.target.value; }}
                          />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                  : ''
              }
              {
                bookingStep4 === true ?
                  <div className="bk-modal__step">
                    <div className="bk-grid">
                      <div className="bk-field bk-field--wide">
                        <FormGroup
                          label={"Address"}
                          labelFor="text-input"
                          labelInfo={"*"}
                        >
                          <GeoComplete
                            className='geo-control'
                            placeholder="Search address"
                            initialValue={attributes.address}
                            onSuggestSelect={this.onAddressSelect.bind(this)}
                            onChange={this.onAddressClear.bind(this)}
                          />
                        </FormGroup>
                      </div>
                      <div className="bk-field bk-field--wide">
                        <FormGroup
                          label={"Address 2"}
                          labelFor="bk-suite"
                        >
                          <input
                            id="bk-suite"
                            type='text'
                            className='bk-input'
                            placeholder='Suite, unit, floor'
                            defaultValue={attributes.suite}
                            onChange={(event) => { attributes.suite = event.target.value; }}
                          />
                        </FormGroup>
                      </div>
                      <div className="bk-field">
                        <FormGroup
                          label={"City"}
                          labelFor="bk-city"
                          labelInfo={"*"}
                        >
                          <input
                            id="bk-city"
                            type='text'
                            className='bk-input'
                            placeholder='City'
                            value={(attributes.city) || ''}
                            onChange={(event) => { attributes.city = event.target.value; }}
                          />
                        </FormGroup>
                      </div>
                      <div className="bk-field">
                        <FormGroup
                          label={"State/province"}
                          labelFor="bk-state"
                          labelInfo={"*"}
                        >
                          <input
                            id="bk-state"
                            type='text'
                            className='bk-input'
                            placeholder='State/province'
                            value={(attributes.state) || ''}
                            onChange={(event) => { attributes.state = event.target.value; }}
                          />
                        </FormGroup>
                      </div>
                      <div className="bk-field">
                        <FormGroup
                          label={"Zip/postal code"}
                          labelFor="bk-zip"
                          labelInfo={"*"}
                        >
                          <input
                            id="bk-zip"
                            type='text'
                            className='bk-input'
                            placeholder='Ex. 0377'
                            value={(attributes.zip) || ''}
                            onChange={(event) => { attributes.zip = event.target.value; }}
                          />
                        </FormGroup>
                      </div>
                    </div>
                  </div>
                  : ''
              }
              {
                bookingStep5 === true ?
                  <div className="bk-modal__step">
                    <div className="bk-grid">
                      {object && object.attributes && object.attributes.start_project_expected_period && (
                      <div className="bk-field">
                        <FormGroup label={"How soon would you like to start?"} labelFor="bk-start-period">
                          <select
                            id="bk-start-period"
                            className='bk-input'
                            placeholder={`Select `}
                            onChange={this.onTimePeriodChange.bind(this)}
                            defaultValue={attributes && attributes.start_project_expected_period}
                          >
                            <option value="">Select any one</option>
                            {object && object.attributes && object.attributes.start_project_expected_period && object.attributes.start_project_expected_period.split(/\r?\n/).map((period) => {
                              var selected = '';
                              if(attributes.start_project_expected_period === period.split(":")[1]){
                                selected = 'selected'
                              }
                              return(
                                <option value={period.split(":")[1]}>{period.split(":")[0]}</option>
                              )})}
                          </select>
                        </FormGroup>
                      </div>
                      )}
                      {object && object.attributes && object.attributes.contact_way && (
                      <div className="bk-field">
                        <FormGroup label={"Best way to contact you"} labelFor="bk-contact-way">
                          <select
                            id="bk-contact-way"
                            className='bk-input'
                            placeholder={`Select `}
                            onChange={this.onContactWayChange.bind(this)}
                            defaultValue={attributes && attributes.contact_way}
                          >
                            <option value="">Select any one</option>
                            {object && object.attributes && object.attributes.contact_way && object.attributes.contact_way.split(/\r?\n/).map((way) => {
                               var selected = '';
                               if(attributes.contact_way === way.split(":")[1]){
                                 selected = 'selected'
                               }
                              return(
                                <option value={way.split(":")[1]}>{way.split(":")[0]}</option>
                              )})}
                          </select>
                        </FormGroup>
                      </div>
                      )}
                    </div>
                    {object && object.attributes && object.attributes.enable_visit_us === true &&
                      <div className="bk-section">
                        <div className="bk-grid">
                          <div className="bk-field booking_form_date">
                            <FormGroup
                              label={"When would you like us to visit?"}
                              labelFor="text-input"
                              labelInfo={"*"}
                            >
                              <BookingDateTimeInput
                                placeholder={'Date'}
                                onChange={this.handleStartDateChange.bind(this)}
                              />
                            </FormGroup>
                          </div>
                        </div>
                      </div>
                    }
                    {object && object.attributes && object.attributes.enable_often_visit_us === true &&
                      <div>
                      {frequency && frequency.length > 0 && <div className="bk-section">
                        <div className="bk-section__head">
                          <span className="bk-label">How often should we visit?</span>
                        </div>
                        <ChoiceGroup label="Visit frequency" className="bk-pills">
                          {
                            frequency.map((freqncy, frequencyKey) => {
                              return (
                                <ChoiceCard
                                  key={freqncy.id || frequencyKey}
                                  className="bk-pill"
                                  checked={frequencyKey == this.state.isFrequencySelected}
                                  onSelect={(event) => { this.onFrequencySelect(event, freqncy, frequencyKey) }}
                                >
                                  {freqncy.title}
                                </ChoiceCard>
                              )

                            })
                          }
                        </ChoiceGroup>
                      </div>}
                    </div>
                    }
                  </div>
                  : ''
              }
              {
                bookingStep6 === true ?
                  <div className="bk-modal__step">
                    {object && object.attributes && object.attributes.payment_method === true &&
                      <div className="bk-section">
                        <div className="bk-section__head">
                          <span className="bk-label">Payment method</span>
                        </div>
                        <ChoiceGroup label="Payment method" className="bk-pills">
                          {
                            items.map((payment, paymentKey) => {
                              return (
                                <ChoiceCard
                                  key={payment.value}
                                  className="bk-pill"
                                  checked={paymentKey === this.state.isPaymentSelect}
                                  onSelect={(event) => { this.onPaymentSelect(event, payment, paymentKey) }}
                                >
                                  {payment.label}
                                </ChoiceCard>
                              )
                            })
                          }
                        </ChoiceGroup>
                      </div>
                    }
                    <div className="bk-section">
                      <div className="bk-section__head">
                        <span className="bk-label">Attachments <span className="bk-optional">Optional</span></span>
                      </div>
                      <div className="bk-upload">
                        <input id="file-upload" className="bk-upload__input" type="file" multiple={true} onChange={this.onChangeFile.bind(this)} />
                        <label htmlFor="file-upload" className="bk-upload__drop">
                          <span className="bk-upload__icon"><Icon icon="cloud-upload" iconSize={18} /></span>
                          <span className="bk-upload__text">
                            <strong>Upload a file</strong>
                            <span>PNG, JPG, GIF, PDF, DOC, DOCX, XLS or XLSX, up to 10 MB</span>
                          </span>
                          {showUploadAttachmentLoader &&
                            <Spinner size={Spinner.SIZE_SMALL} />}
                        </label>
                      </div>
                      {attributes && attributes.booking_attachments.length > 0 &&
                        <ul className="bk-files">
                          {attributes.booking_attachments.map((attachment) => {
                            return (
                              <li className="bk-file" key={attachment.id}>
                                <span className="bk-file__icon"><Icon icon="document" iconSize={14} /></span>
                                <span className="bk-file__text">
                                  <a href={attachment.asset.url} target="_blank" rel="noopener noreferrer" download>{attachment.asset.url.split("/").pop()}</a>
                                  <span className="bk-file__meta">{attachment.asset_content_type}{attachment.asset_human_file_size ? `, ${attachment.asset_human_file_size}` : ''}</span>
                                </span>
                                <Button
                                  minimal={true}
                                  small={true}
                                  icon="trash"
                                  aria-label="Remove file"
                                  onClick={() => this.removeAttachment(attachment)}
                                />
                              </li>
                            )
                          })}
                        </ul>
                      }
                    </div>
                    <div className="bk-section">
                      <FormGroup label={"Note"} labelFor="bk-note" labelInfo={"Optional"}>
                        <textarea
                          id="bk-note"
                          type='text'
                          className='bk-input bk-input--area'
                          placeholder='Anything we should know before we arrive?'
                          defaultValue={attributes.note}
                          onChange={(event) => { attributes.note = event.target.value; }}
                        />
                      </FormGroup>
                    </div>
                  </div>
                  : ''
              }
            </div>

            <div className="bk-modal__actions">
              <Button
                className="bk-btn bk-btn--back"
                minimal={true}
                disabled={bookingStep && bookingStep === 1 ? true : false}
                onClick={this.navigateToPreviousScreen.bind(this)}
                style={{ visibility: `${bookingStep && bookingStep === 1 ? 'hidden' : 'visible'}` }}
                text="Back"
              />
              {bookingStep && bookingStep === 6 ?
                <Button
                  className="bk-btn bk-btn--primary"
                  intent={Intent.PRIMARY}
                  onClick={() => this.createBooking('confirmed')}
                  loading={isLoading}
                >
                  {object && object.attributes && object.attributes.cta_title ? object.attributes.cta_title : 'Confirm booking'}
                </Button>
                :
                <Button
                  className="bk-btn bk-btn--primary"
                  intent={Intent.PRIMARY}
                  onClick={this.navigateToNextScreen.bind(this)}
                  text="Continue"
                />
              }
            </div>
          </div>

          <div className="bk-modal__aside">
            <aside className="bk-ticket" aria-label="Booking summary">
              <div className="bk-ticket__when">
                <span className="bk-ticket__date">{hasStartDate ? startDate.format('ddd, MMM D') : 'Date to be set'}</span>
                {hasStartDate && <span className="bk-ticket__time">{startDate.format('h:mm A')}</span>}
              </div>
              <div className="bk-ticket__body">
                {(customerName || (attributes && attributes.address)) &&
                  <div className="bk-ticket__row">
                    <span className="bk-ticket__icon"><Icon icon="person" iconSize={14} /></span>
                    <div className="bk-ticket__text">
                      <span className="bk-ticket__label">Customer</span>
                      {customerName && <span className="bk-ticket__value">{customerName}</span>}
                      {attributes && attributes.address &&
                        <span className="bk-ticket__muted">
                          {joinAddress(attributes.address, attributes.suite, attributes.city, attributes.state, attributes.zip)}
                        </span>
                      }
                    </div>
                  </div>
                }
                {selectedService ?
                  <div className="bk-ticket__service" style={selectedServiceColor ? { '--bk-service': selectedServiceColor } : undefined}>
                    <span className="bk-ticket__service-name">{selectedService.name}</span>
                    <span className="bk-ticket__muted">{`1 × ${currencyFormattedAmount(parseFloat(selectedService.rate))}`}</span>
                    <span className="bk-ticket__amount">{currencyFormattedAmount(selectedService.rate)}</span>
                  </div>
                  :
                  <p className="bk-ticket__empty">Choose a service to see your estimate.</p>
                }
                {(pricingLines.length > 0 || rangeLines.length > 0) &&
                  <div className="bk-modal__ticket-group">
                    <span className="bk-ticket__label">{pricingTitle}</span>
                    <ul className="bk-ticket__lines">
                      {pricingLines.map((parameter, lineKey) => {
                        return (
                          <li key={`p-${lineKey}`}><span>{parameter.name} × {parameter.quantity}</span><span className="bk-ticket__amount">{currencyFormattedAmount(parameter.total_amount)}</span></li>
                        )
                      })}
                      {rangeLines.map((parameter_range, lineKey) => {
                        return (
                          <li key={`r-${lineKey}`}><span>{parameter_range.name}</span><span className="bk-ticket__amount">{currencyFormattedAmount(parameter_range.price)}</span></li>
                        )
                      })}
                    </ul>
                  </div>
                }
                {extraLines.length > 0 &&
                  <div className="bk-modal__ticket-group">
                    <span className="bk-ticket__label">Add-ons</span>
                    <ul className="bk-ticket__lines">
                      {extraLines.map((ext_service, lineKey) => {
                        return (
                          <li key={`e-${lineKey}`}><span>{ext_service.name}</span><span className="bk-ticket__amount">{currencyFormattedAmount(ext_service.price)}</span></li>
                        )
                      })}
                    </ul>
                  </div>
                }
              </div>
              <div className="bk-ticket__tear" aria-hidden="true"></div>
              <div className="bk-ticket__foot">
                <div className="bk-ticket__total"><span>Total (estimate)</span><strong>{currencyFormattedAmount(this.grand_total)}</strong></div>
                <Button
                  onClick={() => this.createBooking('draft')}
                  className={attributes && attributes.status === 'confirmed' ? "bk-btn bk-btn--secondary disable-save-draft-btn" : "bk-btn bk-btn--secondary"}
                  loading={isLoading}
                  text="Save as draft"
                />
                <p className="bk-ticket__note">Drafts can be confirmed later.</p>
              </div>
            </aside>
          </div>
        </div>

        <div className="bk-modal__powered">Powered by <span>Field Nexus</span></div>
      </Dialog>
    )
  }
}

export default BookingModal;
